import { render, staticRenderFns } from "./tecnicoTurno.vue?vue&type=template&id=79d2885c&scoped=true"
import script from "./tecnicoTurno.vue?vue&type=script&lang=js"
export * from "./tecnicoTurno.vue?vue&type=script&lang=js"
import style0 from "./tecnicoTurno.vue?vue&type=style&index=0&id=79d2885c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2885c",
  null
  
)

export default component.exports